import { motion } from 'framer-motion';

import { INavIcon } from './types';

export default function Upload(props: INavIcon) {
  return (
    <motion.svg
      width={72}
      height={72}
      viewBox="0 0 72 72"
      fill="none"
      {...props}
    >
      <path
        d="M54.2553 14.9612V57.6647C54.2553 58.7182 53.8367 59.7286 53.0918 60.4736C52.3468 61.2186 51.3364 61.6371 50.2829 61.6371H16.5173C15.4638 61.6371 14.4534 61.2186 13.7084 60.4736C12.9634 59.7286 12.5449 58.7182 12.5449 57.6647V8.00952C12.5449 6.95597 12.9634 5.94557 13.7084 5.2006C14.4534 4.45563 15.4638 4.03711 16.5173 4.03711H43.3311L54.2553 14.9612Z"
        fill="#F6F8FF"
      />
      <path
        d="M54.2553 14.9612L44.3242 14.9612C43.778 14.9612 43.3311 14.5144 43.3311 13.9681L43.3311 4.03711L54.2553 14.9612Z"
        fill="#C7D0DD"
      />
      <path
        d="M65.9445 55.0367C65.9445 62.9896 59.4974 69.4367 51.5445 69.4367C43.5916 69.4367 37.1445 62.9896 37.1445 55.0367C37.1445 47.0838 43.5916 40.6367 51.5445 40.6367C59.4974 40.6367 65.9445 47.0838 65.9445 55.0367Z"
        fill="#18192B"
      />
      <path
        d="M57.9416 52.4945C57.0542 48.9595 53.4692 46.8132 49.9342 47.7005C47.1716 48.394 45.1657 50.7817 44.959 53.6224C42.9975 53.9459 41.6696 55.7982 41.9931 57.7597C42.2806 59.5035 43.7916 60.7806 45.559 60.7736H48.5586V59.5737H45.559C44.2336 59.5737 43.1592 58.4993 43.1592 57.174C43.1592 55.8487 44.2336 54.7743 45.559 54.7743C45.8903 54.7743 46.1589 54.5057 46.1589 54.1743C46.1559 51.1923 48.5709 48.7725 51.5529 48.7695C54.1343 48.7669 56.3564 50.5918 56.8557 53.1244C56.8798 53.2478 56.9419 53.3604 57.0334 53.4465C57.1249 53.5326 57.2411 53.5879 57.3657 53.6044C59.0058 53.8379 60.146 55.3569 59.9125 56.997C59.7028 58.4697 58.4453 59.5663 56.9577 59.5737H54.558V60.7736H56.9577C59.2771 60.7666 61.1515 58.8807 61.1445 56.5613C61.1387 54.6307 59.8171 52.9527 57.9416 52.4945Z"
        fill="white"
      />
      <path
        d="M51.1324 54.9487L48.7326 57.3484L49.5785 58.1943L50.9584 56.8205V62.5739H52.1582V56.8205L53.5321 58.1943L54.378 57.3484L51.9783 54.9487C51.7443 54.7161 51.3664 54.7161 51.1324 54.9487Z"
        fill="white"
      />
    </motion.svg>
  );
}
